import { render, staticRenderFns } from "./TeamsportCombinedTable.vue?vue&type=template&id=83daaa7c"
import script from "./TeamsportCombinedTable.vue?vue&type=script&lang=js"
export * from "./TeamsportCombinedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
